import React, { useState, useMemo, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { TabContent, TabPane, Modal, ModalBody } from 'reactstrap'
import {
    InputSelect,
    IconSignCheck,
    IconAssessment,
    ToolTipInfo,
    IconVideo,
    IconHistory,
    ConfirmModal,
    Field,
    Form,
    Select,
    IconLoad
} from '@Knowledge-OTP/znk-ui-components'
import Skeleton from 'react-loading-skeleton'
import CardHeader from '../../../Student/Widget/Components/CardHeader'
import useTranslation from '../../../../../i18n/useTranslation'
// import useGenerateSignedUrlS3 from '../../Model/getSignedUrl'
import useSetObservationToEducator from '../../Model/useSetObservationToEducator'
import moment from 'moment'
import UseAllUsers from '../../../../Calendar/Components/SelectUser/Model/UseAllUsers'
import './index.css'
import { ordenateUserArray } from '../../../../Parent/Utils/ordenateUsersArray'
import updateGeneralInfo from '../../../../../Model/Users/General/updateGeneralInfo'
import { showAlert } from '../../../../../common/Alert/util'
import NotesField from '../../../../Users/Components/NotesField'
import HeaderField from '../../../Student/Widget/PlansList/PlanListItem/HeaderField'

const BodyTable = (props) => {
    const {
        tableToShow = 'current',
        loading: loadQuery,
        refetch: queryRefetch = async () => { },
        educators: queryEducators = [], filterSection = <></> } = props
    const { translate } = useTranslation()
    const dispatch = useDispatch()
    const userSender = useSelector((state) => state.user)
    const timezone = useSelector((state) => state.timezone.zone)
    const [formUrl, setFormUrl] = useState('');
    const [form, setForm] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [searchString, setSearchString] = useState('')
    const [selectedLessons, setSelectedLessons] = useState({})
    const [isOpenEditStaff, setIsOpenEditStaff] = useState(false)
    //eslint-disable-next-line
    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedEducatorId, setSelectedEducatorId] = useState(null)
    const [staffList, setStaffList] = useState([])
    const [sortBy, setSortBy] = useState('name');

    const [sortAsc, setSortAsc] = useState(true);

    const frecuencyList = [{ weekly: translate('profile.actions.frecuency.weekly') },
    { beweekly: translate('profile.actions.frecuency.beweekly') },
    { monthly: translate('profile.actions.frecuency.monthly') },
    { quarterly: translate('profile.actions.frecuency.quarterly') },
    { never: translate('profile.actions.frecuency.never') }]
    //eslint-disable-next-line
    const [getAllUsers, { data: usersList, loading: loadingUsers }] = UseAllUsers()
    const toggleEditStaff = () => {
        setIsOpenEditStaff(!isOpenEditStaff)
    }
    const getDeadline = (date) => {
        if (!date) return null;
        const deadlineDate = moment(date).add(30, 'days');
        const today = moment();
        const daysLeft = deadlineDate.diff(today, 'days');

        return daysLeft;
    };

    const getLessonsToObserve = (educator) => {
        const lessons = educator?.lessons || [];
        return lessons.map(lesson => {
            const studentData = lesson?.planStudent || lesson?.individualStudent;
            const student = studentData
                ? `${studentData.firstName || ''} ${studentData.lastName || ''}`.trim()
                : 'Group Lesson';
            const date = lesson?.startDate ? moment(lesson?.startDate).tz('America/New_York').format('MMM DD, YYYY hh:mm a') : 'No date';

            return {
                ...lesson,
                student,
                date
            };
        });
    };
    //eslint-disable-next-line
    const { submit, loading, validationErrors } = updateGeneralInfo(() => {
        toggleEditStaff()
        queryRefetch()
    }, console.log)
    // const { generateSignedUrl } = useGenerateSignedUrlS3()
    const frecuencyMap = {
        weekly: translate('profile.actions.frecuency.weekly'),
        beweekly: translate('profile.actions.frecuency.beweekly'),
        monthly: translate('profile.actions.frecuency.monthly'),
        quarterly: translate('profile.actions.frecuency.quarterly'),
        never: translate('profile.actions.frecuency.never'),
    }
    useEffect(() => {
        getAllUsers({
            variables: {
                roles: [
                    'SUPER_ADMIN',
                ],
                limit: 0
            }
        })
        //eslint-disable-next-line
    }, [getAllUsers])

    useEffect(() => {
        if (usersList?.allUsers?.docs) {
            setStaffList(usersList?.allUsers?.docs)
        }


    }, [usersList]
    )

    //eslint-disable-next-line
    const [setObservationToEducator, { data: dataSetObervation, loading: loadingSetObervation, error: errorSetObservation }] = useSetObservationToEducator(
        () => queryRefetch(),
        (error) => console.error('Error al guardar observación', error)
    );
    const currentTab = useMemo(() => {
        if (loadQuery) return `loading${capitalize(tableToShow)}`;
        if (queryEducators?.length === 0) return 'blank';
        return tableToShow;
    }, [loadQuery, queryEducators, tableToShow]);

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    const filterEducators = useMemo(() => {
        const search = searchString.toUpperCase();

        const filtered = (queryEducators || []).filter(({ firstName, lastName, observationsBy
        }) => {
            const fullName = `${firstName?.toUpperCase() || ''} ${lastName?.toUpperCase() || ''}`;
            const staffName = observationsBy?.staffName?.toUpperCase() || '';
            // Si estamos en el tab "scheduled", filtramos por ambos campos
            if (tableToShow === 'scheduled') {
                return fullName.includes(search) || staffName.includes(search);
            }
            // Para los otros tabs, solo se filtra por el nombre del educador
            return fullName.includes(search);
        });

        const header =
            tableToShow === 'current'
                ? {
                    isHeader: true,
                    name: 'Name',
                    lessons: 'Lessons to Observe',
                    options: 'Actions',
                    staffAssigned: 'Observer',
                    lastObservation: 'Last Observation',
                    deadline: 'Deadline',
                }
                : tableToShow === 'scheduled'
                    ? {
                        isHeader: true,
                        name: 'Name',
                        hasStudents: 'Has Students',
                        staffAssigned: 'Observer',
                        frecuency: 'Frequency',
                        lastObs: 'Last Observation',
                        options: 'Actions',
                    }
                    : null;

        return header ? [header, ...filtered] : filtered;
    }, [searchString, queryEducators, tableToShow]);
    const filterEducatorsForOverview = useMemo(() => {
        const search = searchString.toUpperCase();

        const filtered = (queryEducators || []).filter(({ firstName, lastName, observationsBy }) => {
            const fullName = `${firstName?.toUpperCase() || ''} ${lastName?.toUpperCase() || '-'}`;
            const staffName = observationsBy?.staffName?.toUpperCase() || '-';
            if (tableToShow === 'scheduled') {
                return fullName.includes(search) || staffName.includes(search);
            }
            return fullName.includes(search);
        })
            // 👇 Acá mapeás y agregás el campo `lastObservationDate`
            .map(educator => {
                const dates = educator?.observationsDates || [];
                const latest = dates.length
                    ? Math.max(...dates.map(o => new Date(o.date).getTime()))
                    : null;

                return {
                    ...educator,
                    // lastObservationDate: latest ? new Date(latest) : null,
                    lastObservationDate: latest ? latest : null,
                };
            });

        const header =
            tableToShow === 'current'
                ? {
                    isHeader: true,
                    name: 'Name',
                    lessons: 'Lessons to Observe',
                    options: 'Actions',
                    staffAssigned: 'Observer',
                    lastObservation: 'Last Observation',
                    deadline: 'Deadline',
                }
                : tableToShow === 'scheduled'
                    ? {
                        isHeader: true,
                        name: 'Name',
                        hasStudents: 'Has Students',
                        staffAssigned: 'Observer',
                        frecuency: 'Frequency',
                        lastObs: 'Last Observation',
                        options: 'Actions',
                    }
                    : null;

        return header ? [header, ...filtered] : filtered;
    }, [searchString, queryEducators, tableToShow]);


    const sortedEducators = [...filterEducatorsForOverview].sort((a, b) => {
        if (a.isHeader || b.isHeader) return 0;

        let aVal, bVal;

        switch (sortBy) {
            case 'name':
                aVal = `${a.firstName} ${a.lastName}`.toLowerCase();
                bVal = `${b.firstName} ${b.lastName}`.toLowerCase();
                break;
            case 'observer':
                aVal = (a?.observationsBy?.staffName || '').toLowerCase();
                bVal = (b?.observationsBy?.staffName || '').toLowerCase();
                break;
            case 'deadline':
                aVal = new Date(a?.nextObservationDate || 0).getTime();
                bVal = new Date(b?.nextObservationDate || 0).getTime();
                break;
            case 'lastObservation':
                aVal = new Date(a?.lastObservationDate || 0).getTime();
                bVal = new Date(b?.lastObservationDate || 0).getTime();
                break;

            default:
                return 0;
        }
        if (aVal < bVal) return sortAsc ? -1 : 1;
        if (aVal > bVal) return sortAsc ? 1 : -1;
        return 0;
    });

    const sortedCurrentEducators = useMemo(() => {
        // Ignoramos si no estamos en el tab correcto
        if (tableToShow !== 'current') return filterEducators;

        const educatorsOnly = filterEducators.filter(e => !e.isHeader);

        const header = filterEducators.find(e => e.isHeader);

        const sorted = [...educatorsOnly].sort((a, b) => {
            let aVal, bVal;

            switch (sortBy) {
                case 'name':
                    aVal = `${a.firstName} ${a.lastName}`.toLowerCase();
                    bVal = `${b.firstName} ${b.lastName}`.toLowerCase();
                    break;
                case 'observer':
                    aVal = (a?.educatorInfo?.observationsBy?.staffName || '').toLowerCase();
                    bVal = (b?.educatorInfo?.observationsBy?.staffName || '').toLowerCase();
                    break;
                case 'deadline':
                    aVal = new Date(a?.nextObservationDate || 0).getTime();
                    bVal = new Date(b?.nextObservationDate || 0).getTime();
                    break;
                case 'lastObservation':
                    aVal = new Date(a?.lastObservationDate || 0).getTime();
                    bVal = new Date(b?.lastObservationDate || 0).getTime();
                    break;
                default:
                    return 0;
            }

            if (aVal < bVal) return sortAsc ? -1 : 1;
            if (aVal > bVal) return sortAsc ? 1 : -1;
            return 0;
        });

        return header ? [header, ...sorted] : sorted;
    }, [filterEducators, sortBy, sortAsc, tableToShow]);

    // function parseS3Url(fullUrl) {
    //     //eslint-disable-next-line
    //     const match = fullUrl.match(/^https:\/\/([^\.]+)\.s3\.amazonaws\.com\/(.+)$/)
    //     if (!match) {
    //         throw new Error('Invalid S3 URL format')
    //     }
    //     const [, bucket, key] = match
    //     return { bucket, key }
    // }

    const handleClickJotform = (data) => {
        if (!selectedLessons?.[data?.educatorId]) {
            return showAlert({ text: "Please select a lesson before proceeding.", status: 'error' }, dispatch)
            // return alert("Please select a lesson before proceeding.");
        }
        const selectedLesson = data?.lessons?.find(lesson => lesson.id === selectedLessons?.[data?.educatorId]);
        const student = selectedLesson?.individualStudent || selectedLesson?.planStudent || selectedLesson?.students?.[0] || {};
        const queryParams = new URLSearchParams({
            'educatorName[first]': data?.firstName || '',
            'educatorName[last]': data?.lastName || '',
            'educatorEmail': data?.email || '',
            'observer': data?.sender || '',
            'observationReason': 'Routine check',
            'studentName[first]': student?.firstName || '',
            'studentName[last]': student?.lastName || '',
            'lessonSubject': selectedLesson?.title || '',
            'lessonRecording': selectedLesson?.recordingUrl || '',
            'time[timeInput]' : moment(selectedLesson?.startDate).tz('America/New_York').format('hh:mm a'),
            'time[ampm]' : moment(selectedLesson?.startDate).tz('America/New_York').format('a').toUpperCase(),
            'dateOf113[month]': moment(selectedLesson?.startDate).tz('America/New_York').format('MM'),
            'dateOf113[day]': moment(selectedLesson?.startDate).tz('America/New_York').format('DD'),
            'dateOf113[year]': moment(selectedLesson?.startDate).tz('America/New_York').format('YYYY'),


        }).toString();

        const fullUrl = `https://form.jotform.com/92235362507859?${queryParams}`;
        setFormUrl(fullUrl);
        setModalOpen(true);
    };

    const handleClickViewLesson = async (educator) => {
        if (!selectedLessons?.[educator._id]) {
            return showAlert({ text: "Please select a lesson before proceeding.", status: 'error' }, dispatch)
        }

        const selectedLesson = educator?.lessons?.find(lesson => lesson.id === selectedLessons?.[educator._id]);
        if (!selectedLesson) return showAlert({ text: "No lesson selected or available for this educator.", status: 'error' }, dispatch)
        const recordingUrl = selectedLesson?.recordingUrl || '';
        if (!recordingUrl) return showAlert({ text: "No recording available for this lesson.", status: 'error' }, dispatch)
        try {
            window.open(recordingUrl, '_blank');
        } catch (err) {
            showAlert({ text: "Failed to generate signed URL", status: 'error' }, dispatch)
            console.error(err);
        }
    }

    const handleClickSetObservation = async (educator) => {
        if (loadingSetObervation) return;
        const selectedLesson = educator?.lessons?.find(lesson => lesson.id === selectedLessons?.[educator._id]);
        if (!selectedLesson) return showAlert({ text: "No lesson selected or available for this educator.", status: 'error' }, dispatch)
        const recordingUrl = selectedLesson?.recordingUrl || '';
        try {
            setObservationToEducator({
                variables: {
                    educatorId: educator._id,
                    classLink: recordingUrl,
                }
            });
        }
        catch (err) {
            showAlert({ text: "Failed to set observation", status: 'error' }, dispatch)
            console.error(err);
        }
    }

    const handleClickOpenModal = (educator) => {
        setForm({
            frecuencyObservations: educator?.frecuencyObservations || translate('profile.actions.frecuency.never'),
            staffId: educator?.observationsBy?.staffId || null,
        })
        setSelectedEducatorId(educator._id)
        setIsOpenEditStaff(true);
    }

    const handleSubmitObservator = (selectedEducatorId, selectedUser, form) => {
        const newVal = {}
        const typeUser = 'educator'
        newVal.userId = selectedEducatorId
        newVal.staffId = form?.staffId || null
        newVal.frecuencyObservations = form?.frecuencyObservations || translate('profile.actions.frecuency.never')
        newVal.typeUser = String(typeUser).toUpperCase()
        submit(newVal)
    }

    const getTooltipText = (observations = []) => {
        if (!observations.length) return { tooltipContent: null, latestDate: null };

        const tooltipContent = observations.map((observation, index) => (
            <span key={index}>
                <small>{moment(observation?.date).format('MMM DD, YYYY')} <br /></small>
                <small>{observation?.staffName} <br /></small>
                <small>********** <br /></small>
            </span>
        ));

        const latestDate = observations
            .map(o => new Date(o.date))
            .reduce((latest, current) => (current > latest ? current : latest));

        return {
            tooltipContent,
            latestDate: moment(latestDate).format('MMM DD, YYYY'),
        };
    };


    return (
        <>
            <CardHeader
                innerInfo={translate("dashboard.educatorObservations.info")}
                filterSection={
                    <div className={`text-gray ml-4 d-flex flex-grid`} style={{ gridGap: '25px' }}>
                        {filterSection}
                    </div>
                }
                showSendAlert={false}
                subtitle={null}
                onReload={() => queryRefetch()}
                loading={loadQuery || loadingSetObervation}
                useSearch
                onChange={(e) => {
                    setSearchString(e.target.value)
                }}
                className={`secondaryBackground`}
                title={`Educators Observations`}
            />
            <div className='d-flex flex-column w-100 m-0 p-0 flex-grow-1'>
                <div className={`secondaryBackground w-100 d-flex flex-column`} style={{ position: 'sticky', top: '119px', zIndex: 10 }}>
                    {/* <div className={`borderTop w-100`} /> */}
                </div>
                <TabContent className={`flex-grow-1 ${currentTab === 'blank' ? 'd-flex flex-column justify-content-center align-items-center' : ''}`} activeTab={currentTab}>
                    <TabPane tabId={`loadingScheduled`}>
                        <div key="header-row" className="educator-grid-row-overview h45 text-gray border-bottom">
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={80} height={20} /></div>
                            <div><Skeleton width={120} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                            {/* <div><Skeleton width={30} height={20} /></div>
                            <div><Skeleton width={30} height={20} /></div> */}
                        </div>
                        {new Array(9).fill(0).map((_, index) => (
                            <div key={index} className={`educator-grid-row-overview ${index % 2 === 0 ? 'secondaryBackground' : 'whiteBackground'}`}>
                                <div><Skeleton width={100} height={20} /></div>
                                <div><Skeleton width={80} height={20} /></div>
                                <div><Skeleton width={120} height={20} /></div>
                                <div><Skeleton width={100} height={20} /></div>
                                <div><Skeleton width={100} height={20} /></div>
                                <div><Skeleton circle={true} width={24} height={24} /></div>
                                <div><Skeleton width={30} height={20} /></div>
                            </div>
                        ))}
                    </TabPane>
                    <TabPane tabId={`loadingCurrent`}>
                        <div key="header-row" className="educator-grid-row h45 text-gray border-bottom">
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                            <div><Skeleton width={100} height={20} /></div>
                        </div>
                        {new Array(9).fill(0).map((_, index) => (
                            <div key={index} className={`educator-grid-row ${index % 2 === 0 ? 'secondaryBackground' : 'whiteBackground'}`}>
                                {/* Name */}
                                <div><Skeleton width={120} height={20} /></div>

                                {/* Lesson Selector */}
                                <div><Skeleton width="100%" height={32} /></div>

                                {/* Options */}
                                <div className="d-flex flex-row align-items-center gap-2">
                                    <Skeleton circle={true} width={20} height={20} />
                                    <Skeleton circle={true} width={24} height={24} />
                                    <Skeleton circle={true} width={20} height={20} />
                                </div>

                                {/* Last Observation */}
                                <div><Skeleton width={100} height={20} /></div>

                                {/* Deadline */}
                                <div><Skeleton width={150} height={20} /></div>
                            </div>
                        ))}
                    </TabPane>
                    <TabPane tabId={`blank`}>
                        <div className={`d-flex flex-row justify-content-center w-100`} style={{ height: '200px' }}>
                            <div className={`d-flex flex-column justify-content-center align-items-center text-center`}>
                                <label className={`h45 mt-4 text-gray`}>No educators to show</label>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId={`current`}>
                        {sortedCurrentEducators?.map((educator, index) => {
                            const observer = educator?.educatorInfo?.observationsBy?.staffName || 'None';
                            if (educator.isHeader) {
                                return (
                                    <div key="header-row" className="educator-grid-row h45 text-gray border-bottom">
                                        {/* <div >{educator.name}</div>
                                         */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'name'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('name');
                                                    setSortAsc(sortBy === 'name' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.name}
                                            </HeaderField>
                                        </div>

                                        <div >{educator.lessons}</div>
                                        <div >{educator.options}</div>
                                        {/* <div >{educator.staffAssigned}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'observer'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('observer');
                                                    setSortAsc(sortBy === 'observer' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.staffAssigned}
                                            </HeaderField>
                                        </div>

                                        {/* <div >{educator.lastObservation}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'lastObservation'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('lastObservation');
                                                    setSortAsc(sortBy === 'lastObservation' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.lastObservation}
                                            </HeaderField>
                                        </div>
                                        {/* <div >{educator.deadline}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'deadline'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('deadline');
                                                    setSortAsc(sortBy === 'deadline' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.deadline}
                                            </HeaderField>
                                        </div>

                                    </div>
                                );
                            }
                            const lessonsToObserve = getLessonsToObserve(educator)
                            // const { latestDate } = getTooltipText(educator?.observationsDates || []);
                            return (
                                <div
                                    key={educator._id}
                                    className={`educator-grid-row ${index % 2 === 0 ? 'secondaryBackground' : 'whiteBackground'}`}
                                >
                                    {/* Name */}
                                    <span className="h4 text-info">
                                        {educator.firstName} {educator.lastName}
                                    </span>

                                    {/* Lessons to Observe */}
                                    <div>
                                        <InputSelect
                                            className="m-0 p-0 mt-1 text-gray"
                                            style={{ width: '100%' }}
                                            name="lesson"
                                            value={selectedLessons?.[educator._id]}
                                            type="text"
                                            placeholder="Select lesson"
                                            options={lessonsToObserve?.map(lesson => ({
                                                value: lesson?.id,
                                                label: `${lesson?.title}, ${moment(lesson?.date).tz(timezone).format('MMM DD YYYY, hh mm a')} - ${lesson?.student}`,
                                            }))}
                                            onChange={res => {
                                                setSelectedLessons(prev => ({
                                                    ...prev,
                                                    [educator._id]: res,
                                                }));
                                            }}
                                        />
                                    </div>

                                    {/* Options */}
                                    <div className="d-flex flex-row align-items-center">
                                        <ToolTipInfo tooltipId={`recording-${index}`} innerElement={<div>{translate("dashboard.educatorObservations.recording")}</div>} place="bottom">
                                            <div className="hover-icon" onClick={() => handleClickViewLesson(educator)}>
                                                <IconVideo className="text-gray" size={20} />
                                            </div>
                                        </ToolTipInfo>
                                        <ToolTipInfo tooltipId={`feedback-${index}`} innerElement={<div>{translate("dashboard.educatorObservations.feedback")}</div>} place="bottom">
                                            <div
                                                className="hover-icon"
                                                onClick={() =>
                                                    handleClickJotform({
                                                        educatorId: educator._id,
                                                        firstName: educator.firstName,
                                                        lastName: educator.lastName,
                                                        email: educator.email,
                                                        sender: `${userSender?.firstName || ''} ${userSender?.lastName || ''}`,
                                                        lessons: educator?.lessons || [],
                                                    })
                                                }
                                            >
                                                <IconAssessment className="text-primary" size={24} color="#778699" />
                                            </div>
                                        </ToolTipInfo>
                                        <ToolTipInfo tooltipId={`setObs-${index}`} innerElement={<div>{translate("dashboard.educatorObservations.setObs")}</div>} place="bottom">
                                            <div className="hover-icon" onClick={() => loadingSetObervation ? null : handleClickSetObservation(educator)}>
                                                {loadingSetObervation ? <IconLoad className="text-primary" size={20}/> : <IconSignCheck className="text-primary" size={20} />}
                                            </div>
                                        </ToolTipInfo>
                                    </div>

                                    {/* Observer */}
                                    <span
                                        key={`obs-${index}`}
                                        className="text-gray h45">
                                        {observer}
                                        {/* {educator?.staffName || '-'} */}
                                    </span>

                                    {/* Last Observation */}
                                    <span className="h45 text-gray">
                                        {moment(educator?.lastObservationDate).format('MMM DD, YYYY') || '-'}
                                    </span>
                                    {/* Deadline */}
                                    <div>
                                        <ToolTipInfo
                                            tooltipId={`observation-${index}`}
                                            innerElement={<div>{moment(educator?.nextObservationDate).add(30, 'days').format('MMM DD, YYYY')}</div>}
                                            place="bottom"
                                        >
                                            <span
                                                className={`h45 ${(() => {
                                                    const days = getDeadline(educator?.nextObservationDate);
                                                    if (days == null) return 'text-gray';
                                                    if (days < 0 || days <= 5) return 'text-danger-strong';
                                                    if (days <= 15) return 'text-orange-strong';
                                                    return 'text-gray';
                                                })()
                                                    }`}
                                            >
                                                {(() => {
                                                    const days = getDeadline(educator?.nextObservationDate);
                                                    if (days == null) return '-';
                                                    if (days > 0) return `${days} days to complete`;
                                                    if (days === 0) return 'Due today';
                                                    return `Overdue by ${Math.abs(days)} days`;
                                                })()}
                                            </span>
                                        </ToolTipInfo>
                                    </div>
                                </div>

                            );
                        })}
                    </TabPane>
                    <TabPane tabId={`scheduled`}>
                        {sortedEducators?.map((educator, index) => {
                            const { tooltipContent, latestDate } = getTooltipText(educator?.observationsDates || []);
                            if (educator.isHeader) {
                                return (
                                    <div key="header-row" className="educator-grid-row-overview h45 text-gray border-bottom">
                                        {/* <div >{educator.name}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'name'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('name');
                                                    setSortAsc(sortBy === 'name' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.name}
                                            </HeaderField>
                                        </div>
                                        <div >{educator.hasStudents}</div>
                                        {/* <div >{educator.staffAssigned}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'observer'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('observer');
                                                    setSortAsc(sortBy === 'observer' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.staffAssigned}
                                            </HeaderField>
                                        </div>
                                        <div >{educator.frecuency}</div>
                                        {/* <div >{educator.lastObs}</div> */}
                                        <div>
                                            <HeaderField
                                                active={sortBy === 'lastObservation'}
                                                order={sortAsc}
                                                onClick={() => {
                                                    setSortBy('lastObservation');
                                                    setSortAsc(sortBy === 'lastObservation' ? !sortAsc : true);
                                                }}
                                            >
                                                {educator.lastObs}
                                            </HeaderField>
                                        </div>

                                        <div ></div>
                                        <div></div>
                                    </div>
                                );
                            }

                            return (
                                <div
                                    key={educator._id}
                                    className={`educator-grid-row-overview ${index % 2 === 0 ? 'secondaryBackground' : 'whiteBackground'}`}
                                >
                                    {/* Name */}
                                    <span
                                        className="h4 text-info">
                                        {educator.firstName} {educator.lastName}
                                    </span>
                                    {/* Has Students */}
                                    <span
                                        className="d-inline-block px-2 py-1 text-center h45"
                                        style={{
                                            backgroundColor: educator.hasStudents ? '#D1FAE5' : '#FECACA',
                                            color: educator.hasStudents ? '#065F46' : '#991B1B',
                                            fontWeight: 'bold',
                                            borderRadius: '999px',
                                            fontSize: '0.8rem',
                                            padding: '2px 8px',
                                            lineHeight: '1',
                                            width: '40%',
                                        }}
                                    >
                                        {educator.hasStudents ? 'Yes' : 'No'}
                                    </span>
                                    {/* Observations */}
                                    <td>
                                        <span
                                            className="cell-hover text-gray h45"
                                            onClick={() => handleClickOpenModal(educator)}
                                        >
                                            {educator?.observationsBy?.staffName || ''}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            className="cell-hover text-gray h45"
                                            onClick={() => handleClickOpenModal(educator)}
                                        >
                                            {frecuencyMap[educator?.frecuencyObservations] || '-'}
                                        </span>
                                    </td>
                                    {/* Last Observation */}
                                    <div className='justify-content-start align-items-center h45 text-gray'>
                                        {latestDate}
                                    </div>
                                    {/* History */}
                                    <ToolTipInfo
                                        tooltipId={`observation-${index}`}
                                        disable={false}
                                        innerElement={<div>{tooltipContent}</div>}
                                        place="bottom"
                                    >
                                        <div className="text-gray h45 d-flex align-items-center">
                                            <IconHistory className="ml-1" size={24} color={'#778699'} />
                                        </div>
                                    </ToolTipInfo>
                                    {/* Notes */}
                                    <div className="justify-content-start align-items-center text-gray">
                                        <NotesField item={educator} onSave={() => { queryRefetch() }} />
                                    </div>
                                </div>
                            );
                        })}
                    </TabPane>
                </TabContent>
            </div>
            <Modal 
                // backdrop='static'
                isOpen={modalOpen}
                toggle={() => setModalOpen(false)}
                size="lg"
                style={{
                    maxWidth: '1000px',
                    width: '90%',
                }}
            >
                <ModalBody style={{ padding: 0, height: '90vh', width: '90vh', overflow: 'hidden' }}>
                    <iframe
                        title="Observation Form"
                        src={formUrl}
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            overflow: 'hidden',
                        }}
                    />
                </ModalBody>
            </Modal>
            <ConfirmModal
                className=''
                classNameActionDiv='d-flex flex-row'
                classNameConfirm='text-primary text-right'
                classNameCancel='text-gray text-right'
                isOpen={isOpenEditStaff}
                toggle={() => { toggleEditStaff() }}
                loading={loading || loadingUsers || loadingSetObervation}
                title={translate('dashboard.educatorObservations.confirmModal.title')}
                body={
                    <Form value={form} onChange={setForm} validationErrors={{}}>
                        {
                            <>
                                <label className='text-gray font-weight-light mt-3 mb-2'>{translate('profile.actions.editGeneralInfo.frecuency')}</label>
                                <Field
                                    type={InputSelect}
                                    component={Select}
                                    fieldName='frecuencyObservations'
                                    className='h-100 pr-1'
                                    options={frecuencyList.map((frecuency) => {
                                        const [key, value] = Object.entries(frecuency)[0];
                                        return { label: value, value: key };
                                    })}

                                    value={form?.frecuencyObservations}
                                    listItem='small'
                                    itemDivider='middle'
                                    multiple={false}
                                    onChange={(e) => {
                                        setForm({
                                            ...form,
                                            frecuencyObservations: e
                                        })
                                    }}
                                />
                                <label className='text-gray font-weight-light mt-3 mb-2'>{translate('profile.actions.editGeneralInfo.observer')}</label>
                                <Field
                                    type={InputSelect}
                                    component={Select}
                                    fieldName='staffId'
                                    className='h-100 pr-1'
                                    options={ordenateUserArray(staffList)?.map((staff) => ({
                                        label: staff.name,
                                        value: staff.id,
                                    }))}

                                    value={form?.staffId}
                                    listItem='small'
                                    itemDivider='middle'
                                    multiple={false}
                                    onChange={(e) => {
                                        setForm({
                                            ...form,
                                            staffId: e
                                        })
                                    }}
                                />
                            </>
                        }

                    </Form>
                }
                confirmAction={() => {
                    handleSubmitObservator(selectedEducatorId, selectedUser, form)
                }}
                cancelAction={() => { toggleEditStaff() }}
                confirmText={translate('dashboard.educatorObservations.confirmModal.confirm')}
                cancelText={translate('dashboard.educatorObservations.confirmModal.cancel')}
            />
        </>
    )
}

export default BodyTable;
